import React, {useEffect, useState} from "react";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useSelector} from "react-redux";
import {useHistory, useParams} from "react-router-dom";
import LoadingSpinner from '../../../components/loading-spinner';
import Button from "../../../components/button";
import SelectInput from "../../../components/select";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {ReactComponent as ReactLogo} from '../../../button.svg';
import { searchUserTeamsActivity, searchMonthlyMonitoring } from "../../../redux/activities";
import {searchStores} from "../../../redux/stores";
import Footer from "../../../components/footer";

function data_years() {
    const year = new Date().getFullYear();
    let data = [] 
    for (var i = year - 4; i <= year; i++) {
        data.push({'id': i, 'name': i});
    }
    return data;
}

const MonthlyMonitoringItem = (props) => {
    let history = useHistory();

    const {id, nombre, id_user, user, id_store, store, mes, anio} = useParams();
    
    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const [id_tienda, setIdTienda] = useState(id_store);
    const [stores, setStores] = useState([]);
    const [month, setMonth] = useState(mes);
    const [name_month, setNameMonth] = useState('');
    const [year, setYear] = useState(anio);
    const [isLoading, setIsLoading] = useState(false);
    const [id_usuario, setIdUsuario] = useState(id_user);
    const [users, setUsers] = useState([]);
    const [datas, setDatas] = useState([]);
    const [percentage_store, setPercentageStore] = useState(0);
    const [percentage_user, setPercentageUser] = useState(0);

    const years = data_years();

    const filter_month = [
        {name: "Enero", id: 1},
        {name: "Febrero", id: 2},
        {name: "Marzo", id: 3},
        {name: "Abril", id: 4},
        {name: "Mayo", id: 5},
        {name: "Junio", id: 6},
        {name: "Julio", id: 7},
        {name: "Agosto", id: 8},
        {name: "Septiembre", id: 9},
        {name: "Octubre", id: 10},
        {name: "Noviembre", id: 11},
        {name: "Diciembre", id: 12}
    ];

    useEffect(() => {
        if (id_user !== 0) {
            getStores(id_user);
        }
        if (mes !== 0) {
            let m = filter_month.filter(x => x.id === parseInt(mes));
            if (m.length > 0) {
                setNameMonth(m[0].name);
                getMonthlyMonitoring();
            }
        }
        // eslint-disable-next-line
    }, [id_user]);

    useEffect(() => {
        getUserTeamsActivity(token);
        // eslint-disable-next-line
    }, [token]);

    async function getUserTeamsActivity(token) {
        setIsLoading(true);
        let params = '';
        try {
            const response = await searchUserTeamsActivity(token, params);
            if (response && response.data && response.data.datos) {
                setUsers(response.data.datos);
            }
            setIsLoading(false);
        } catch (e) {
           setIsLoading(false);
        }
    }

    async function getStores(id_user) {
        setIsLoading(true);
        const params = '?id_usuario=' + id_user
        try {
            const response = await searchStores(token, params);
            if (response && response.data && response.data.datos) {
                setStores(response.data.datos);
            }
            setIsLoading(false);
        } catch (e) {
           setIsLoading(false);
        }
    }

    const changeUser = (e) => {
        document.getElementById('id_tienda').selectedIndex = 0;
        if (parseInt(e.target.value) !== 0) {
            setIdUsuario(parseInt(e.target.value));
            getStores(parseInt(e.target.value));
        } else {
            setIdTienda(0);
            setStores([]);
        }
    }

    const filterMonth = (e) => {
        setMonth(e.target.value);
    }

    const filterYear = (e) => {
        setYear(e.target.value);
    }

    async function getMonthlyMonitoring() {
        setIsLoading(true);
        console.log('id_usuario');
        console.log(month, year);
        if (parseInt(id_usuario) === 0) {
            toast.error("Debe seleccionar un usuario", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (parseInt(id_tienda) === 0) {
            toast.error("Debe seleccionar un tienda", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (parseInt(month) === 0) {
            toast.error("Debe seleccionar una mes", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (parseInt(year) === 0) {
            toast.error("Debe seleccionar el año", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        let v_month = month.toString()
        if (v_month.length === 1) {
            v_month = '0' + v_month;
        }
        var day = (new Date(year, v_month, 0)).getDate();
        const date_start = year.toString() + '-' + v_month.toString() + '-01';
        const date_end = year.toString() + '-' + v_month.toString() + '-' + day.toString();

        let params = '?id_usuario=' + id_usuario + '&&id_tienda=' + id_tienda + '&&id_hoja_trabajo=' + id + '&&fecha_inicio=' + date_start + '&&fecha_fin=' + date_end;
        try {
            const response = await searchMonthlyMonitoring(token, params);
            if (response && response.data && response.data.datos) {
                setDatas(response.data.datos);
                setPercentageStore(response.data.porcentaje_tienda);
                setPercentageUser(response.data.porcentaje_usuario);
            }
            setIsLoading(false);
        } catch (e) {
           setIsLoading(false);
        }
    }

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                    <Breadcrumbs
                            title="Seguimiento mensual"
                            items={[{label: "Consulta de acividades", link: "/segumiento-mensual"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div><ToastContainer/></div>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                <div className="d-flex">
                                    <div style={{cursor: 'pointer'}} onClick={() => {
                                        history.push(`/segumiento-mensual`);
                                    }}>
                                        <ReactLogo width={50} heght={40}/>
                                    </div>
                                    <p className="ml-1" style={{marginTop: 5, fontSize: 18, color: '#727E8C'}}>Cumplimiento mensual de {nombre}</p>
                                </div>
                                <div className="row mt-1">
                                    <div className="col-12">
                                        <div className="border_card row">
                                            <div className="col-md-3 col-sm-6 col-12">
                                                <div className="form-group">
                                                    <label>Usuario</label>
                                                    <SelectInput
                                                        label="Usuario"
                                                        name="id_usuario"
                                                        value={id_usuario}
                                                        onChange={changeUser}
                                                        select={user}
                                                        options={users ? users.map((item) => ({
                                                            name: item.nombres,
                                                            id: item.id,
                                                        })) : []}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3 col-sm-6 col-12">
                                                <div className="form-group">
                                                    <label>Tienda</label>
                                                    <SelectInput
                                                        label="Tienda"
                                                        id="id_tienda"
                                                        name="id_tienda"
                                                        value={id_tienda}
                                                        select={store}
                                                        onChange={(e) => setIdTienda(parseInt(e.target.value))}
                                                        options={stores ? stores.map((item) => ({
                                                            name: item.nombre,
                                                            id: item.id,
                                                        })) : []}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3 col-sm-6 col-12">
                                                <label>Mes</label>
                                                <SelectInput
                                                    id="month"
                                                    name="filtro"
                                                    options={filter_month}
                                                    onChange={filterMonth}
                                                    select={name_month}
                                                />
                                            </div>
                                            <div className="col-md-3 col-sm-6 col-12">
                                                <label>Año</label>
                                                <SelectInput
                                                    id="year"
                                                    name="year"
                                                    options={years}
                                                    onChange={filterYear}
                                                    select={parseInt(anio)}
                                                />
                                            </div>
                                            <div className="col-12 text-center mt-1">
                                                <Button type="button" text="Buscar" theme="calendar" onClick={() => {
                                                    getMonthlyMonitoring();
                                                }}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-12 p-1">
                                        <div className="border_card list-content d-flex">
                                            <p className="text-bold-700"
                                                style={{fontSize: 16, width: '60%'}}>Porcentaje cumplimiento persona</p>
                                            <div className="text-right" style={{width: '40%'}}>
                                                <p className="text-bold-700" style={{
                                                    color: '#FFC912',
                                                    fontSize: 20
                                                }}>{parseFloat(percentage_user).toFixed(2)} %</p>
                                                <div className="progress mt-1">
                                                    <div className="progress-bar bg-calendar"
                                                            role="progressbar"
                                                            style={{width: percentage_user + '%'}}
                                                            aria-valuenow="100" aria-valuemin="0"
                                                            aria-valuemax="100"></div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-12 p-1">
                                        <div className="border_card list-content d-flex">
                                            <p className="text-bold-700"
                                                style={{fontSize: 16, width: '60%'}}>Porcentaje cumplimiento tienda</p>
                                            <div className="text-right" style={{width: '40%'}}>
                                                <p className="text-bold-700" style={{
                                                    color: '#FFC912',
                                                    fontSize: 20
                                                }}>{parseFloat(percentage_store).toFixed(2)} %</p>
                                                <div className="progress mt-1">
                                                    <div className="progress-bar bg-calendar"
                                                            role="progressbar"
                                                            style={{width: percentage_store + '%'}}
                                                            aria-valuenow="100" aria-valuemin="0"
                                                            aria-valuemax="100"></div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-1">
                                    {datas &&
                                        datas.map(x => (
                                            <div className="col-md-4 col-sm-6 col-12" style={{cursor: 'pointer'}} onClick={() => {
                                                history.push(`/seguimiento/${id}/${nombre}/${x.id_proceso}/${x.proceso}/${month}/${year}/${id_usuario}/${x.usuario}/${id_tienda}/${x.tienda}`);
                                            }}>
                                                <div style={{background: x.color_div}} className="p-1">
                                                    <strong className="ml-1" style={{marginTop: 10, fontSize: 20, color: x.color}}>{x.proceso}</strong><br/>
                                                    <strong className="ml-1" style={{marginTop: 10, fontSize: 14, color: x.color}}>Actividades {x.completo_usuario}/{x.n_actividades}</strong><br/>
                                                    <span className="ml-1" style={{marginTop: 10, fontSize: 14, color: x.color}}>{x.estado}</span><br/>
                                                </div>
                                            </div>
                                        ))}
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default MonthlyMonitoringItem;
